import {outter_post,post} from 'common/js/axios-helper';
import {SystemPropApi,Broker} from "./constant/UrlMapper";

const host = "8885"


const add = (data) => {
    return outter_post(SystemPropApi.Add, data, host);
};
const list = (data) => {
    return outter_post(SystemPropApi.List, data, host);
};
const detail = (data) => {
    return outter_post(SystemPropApi.Detail, data, host);
};

const update = (data) => {
    return outter_post(SystemPropApi.Update, data, host);
};

const exist = (data) => {
    return outter_post(SystemPropApi.Exist, data, host);
};

const meltList = (data) => {
    return outter_post(SystemPropApi.meltList, data, host);
};

const meltEdit = (data) => {
    return outter_post(SystemPropApi.meltEdit, data, host);
};
// - -------------------个人的
const meltListPeo = (data) => {
    return post(SystemPropApi.meltListPeo, data, host);
};

const meltEditPeo = (data) => {
    return post(SystemPropApi.meltEditPeo, data, host);
};

const meltAddPeo = (data) => {
    return post(SystemPropApi.meltAddPeo, data, host);
};

//----------------------------------------------代理和商户管理相关接口
const brokerList = (data) => {
    return post(Broker.list, data, host);
};
const brokerAdd = (data) => {
    return post(Broker.add, data, host);
};
const brokerDel = (data) => {
    return post(Broker.delete, data, host);
};
const businList = (data) => {
    return post(Broker.businList, data, host);
};
const businAdd = (data) => {
    return post(Broker.businAdd, data, host);
};
const businDel = (data) => {
    return post(Broker.businDelete, data, host);
};

export default {meltListPeo,meltEditPeo,meltAddPeo,add, list, detail, update,exist, meltList, meltEdit,brokerList,brokerAdd,businList,businAdd,brokerDel,businDel}



// WEBPACK FOOTER //
// ./src/service/SystemPropertiesService.js